module.exports = __webpack_public_path__ + "static/img/医嘱与病历_场景一.b3d41bb6.png";